export const ONE_ON_ONE_UI = {
  UI_CHANGE: "UI_CHANGE",
}

export const CALL_VIEW = {
  STANDARD: 'standard',
  MINIMIZED: 'minimized',
  SCREENSHARE: 'screenshare',
}